export enum LCAppId {
	main = 0,
	recorderLoops = 1
}

export function getLcAppNameById(appId:LCAppId):string {
	switch (appId){
		case LCAppId.main: {
			return "LoopCollab";
		}
		case LCAppId.recorderLoops: {
			return "RecorderLoops";
		}
	}
}